import React from 'react';
import { Modal, Card, Select, DatePicker, Form } from 'antd';
import moment from 'moment';
import styles from './Index.less';

const { Option } = Select;
const { RangePicker } = DatePicker;
const FormItem = Form.Item;

@Form.create()
export default class ExportDetailModal extends React.Component {
  handleonOk() {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onOk) {
          this.props.onOk({
            orgId: values.orgId === 'all' ? undefined : values.orgId,
            startDate: moment(values.time[0])
              .startOf('day')
              .format('x'),
            endDate: moment(values.time[1])
              .add('days', 1)
              .startOf('day')
              .format('x'),
          });
        }
      }
    });
  }

  handleOnCancel() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  renderSchools() {
    const { relateSchools } = this.props;
    if (relateSchools.length === 0) {
      return null;
    }

    const ret = [
      <Option key="all-school" value="all">
        全部学校
      </Option>,
    ];

    relateSchools.forEach(school => {
      ret.push(
        <Option key={school.orgId} value={school.orgId}>
          {school.orgName}
        </Option>
      );
    });

    return ret;
  }

  renderContent = () => {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };

    return (
      <Form className={styles.root}>
        <FormItem {...formItemLayout} label="时间">
          {getFieldDecorator('time', {
            initialValue: [moment(), moment()],
            rules: [{ required: true, message: '请选择时间' }],
          })(<RangePicker />)}
        </FormItem>
        <FormItem {...formItemLayout} label="学校">
          {getFieldDecorator('orgId', {
            initialValue: 'all',
            rules: [{ required: true, message: '请选择学校' }],
          })(<Select>{this.renderSchools.call(this)}</Select>)}
        </FormItem>
      </Form>
    );
  };

  render() {
    const { visible, loading } = this.props;

    if (visible !== true) {
      return null;
    }

    return (
      <Modal
        visible={visible}
        title="导出明细"
        onCancel={this.handleOnCancel.bind(this)}
        onOk={this.handleonOk.bind(this)}
        confirmLoading={loading === true}
      >
        <Card bordered={false} loading={loading}>
          {this.renderContent.call(this)}
        </Card>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/ExportDetailModal/Index.js